/**
 * Отображение баланса игрока
 */

import * as PIXI from 'pixi.js';
import { TextStyle } from 'pixi.js';
import { COLORS } from '@/config/colors';
import type { Lang } from '@/utils/storage';

const TEXTS = {
  ru: { balance: 'Баланс' },
  en: { balance: 'Balance' },
};

export class BalanceDisplay extends PIXI.Container {
  private label: PIXI.Text;
  private value: PIXI.Text;

  constructor() {
    super();
    this.label = new PIXI.Text(
      TEXTS.ru.balance,
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 18,
        fill: COLORS.textSecondary,
      })
    );
    this.value = new PIXI.Text(
      '$999.5',
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 24,
        fill: COLORS.textPrimary,
        fontWeight: 'bold',
      })
    );
    this.label.anchor.set(0, 0.5);
    this.value.anchor.set(0, 0.5);
    this.label.y = 0;
    this.value.y = 0;
    this.value.x = this.label.width + 10;
    this.addChild(this.label);
    this.addChild(this.value);
  }

  setBalance(balance: number): void {
    this.value.text = `$${balance.toFixed(2)}`;
  }

  setLang(lang: Lang): void {
    this.label.text = TEXTS[lang].balance;
  }
}
